module.exports = __webpack_public_path__ + "7f7f53624f69685f4c73f754cb316d35.png";